import styles from "./index.module.less";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import { SafeArea, Image } from "antd-mobile"
import { getUrbanCarbonRankList, IUrbanCarbonRankItem } from "~src/service/urbanCarbonSecrets"
import React,{ FC, useEffect, useState } from "react";
import { rank_list_title, rank_first, rank_two, rank_three } from "~src/assets/images/urbanCarbonSecrets"
import classnames from "classnames";
interface IRankDataType {
  ranking: IUrbanCarbonRankItem[],
  rank: IUrbanCarbonRankItem
}
const RankList: FC = () => {
  useDocumentTitle('城市碳秘');
  const [rankData, setRankData] = useState<IRankDataType>()
  const getRankList = async () => {
    const res = await getUrbanCarbonRankList()
    if (res && res.ranking) {
      setRankData(res)
    }
  }
  useEffect(() => { getRankList() }, [])
  return <div className={styles.container}>
    <img className={styles.header_bg} src="https://resources-cn.miotech.com/static/mp2c/images/activity/urban-carbon-secrets/rank_header.png" alt="" />
    <div className={styles.content}>
      <div className={styles.ruleTitle} style={{ backgroundImage: `url(${rank_list_title})` }}>
        城市碳秘排行榜
      </div>
      <div className={styles['content-remarks']}>最终排名以活动结束当日公示为准。</div>
      {rankData?.rank && <div className={styles['content-self']}>
        <div className={classnames(styles.sort, styles['content-self-sort'])}>{
          rankData?.rank?.sort > 3 ? <span>{rankData?.rank?.sort}</span> : <Image src={rankData?.rank?.sort === 1 ? rank_first : rankData?.rank?.sort === 2 ? rank_two : rank_three}></Image>
        }</div>
        <div className={styles.info}>
          <Image src={rankData?.rank?.avatar}
            fit='cover'
            width={24}
            height={24}
            style={{ borderRadius: 32 }} />
          <div className={styles["info-name"]} >{rankData?.rank?.nikeName}</div>
        </div>
        <div className={styles.topiccount}>{rankData?.rank?.pushNum}</div>
        <div className={styles.linkcount}>{rankData?.rank?.likeNum}</div>
      </div>}
      <div className={styles['rank-header']}>
        <div className={styles.sort}>排名</div>
        <div className={styles.info}>姓名</div>
        <div className={styles.topiccount}>笔记数</div>
        <div className={styles.linkcount}>点赞数</div>
      </div>
      <div className={styles['rank-body']}>
        {
          (rankData?.ranking ?? []).map(item => {
            return <div key={item.sort} className={styles['rank-body-item']}>
              <div className={styles.sort}>{
                item.sort > 3 ? <span>{item.sort}</span> : <Image src={item.sort === 1 ? rank_first : item.sort === 2 ? rank_two : rank_three}></Image>
              }</div>
              <div className={styles.info}>
                <Image src={item.avatar}
                  fit='cover'
                  width={24}
                  height={24}
                  style={{ borderRadius: 32 }} />
                <div className={styles["info-name"]} >{item.nikeName}</div>
              </div>
              <div className={styles.topiccount}>{item.pushNum}</div>
              <div className={styles.linkcount}>{item.likeNum}</div>
            </div>
          })
        }

      </div>
    </div>
    <SafeArea position='bottom' />
  </div >
}
export default RankList